import * as React from 'react';

import { Button } from 'src/registry/ui/Button';
import { Calendar } from 'src/registry/ui/Calendar';
import { Popover, PopoverContent, PopoverTrigger } from 'src/registry/ui/Popover';
import { cn } from 'src/utils/shadcn';

interface DatePickerProps extends Omit<React.HTMLAttributes<HTMLInputElement>, 'onSelect' | 'onChange'> {
    buttonValue: string;
    onChange: (date: Date | undefined) => void;
    value?: Date;
    className?: string;
    /** The latest day that can be picked. The later ones are not selectable and cannot be reached. */
    maxDate?: Date;
}

const DatePicker = ({ onChange, value, buttonValue, className, maxDate }: DatePickerProps) => {
    const [isOpen, setIsOpen] = React.useState(false);
    const togglePopover = React.useCallback(() => setIsOpen((prevState) => !prevState), []);
    return (
        <Popover open={isOpen} onOpenChange={togglePopover}>
            <PopoverTrigger asChild>
                <Button id="date" variant="outline" className={cn('justify-center p-2 text-sm font-normal', className)}>
                    {buttonValue}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-auto p-0" align="start" side="bottom" portal={false}>
                <Calendar
                    mode="single"
                    onSelect={(date) => {
                        onChange(date);
                        togglePopover();
                    }}
                    timeZone="UTC"
                    selected={value}
                    defaultMonth={value}
                    required={false}
                    disabled={maxDate ? { after: maxDate } : undefined}
                    endMonth={maxDate}
                />
            </PopoverContent>
        </Popover>
    );
};

export default DatePicker;
